import React, { useState } from "react";

export const Paragraph = ({
                       text,
                       type = "",
                       maxChars = 5000,
                       shouldTruncateText = false,
                       viewMoreText = "Read more",
                       viewLessText = "Read less",
                        classes="",
                        style = {}
                   }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const shouldTruncate = shouldTruncateText && maxChars > 0 && typeof text === 'string' && text.length > maxChars;
    const truncatedText = shouldTruncate
        ? text.substring(0, maxChars) + "..."
        : text;

    const renderText = () => {
        if (typeof text === "string") {
            // Render as plain text with truncation and expansion
            return (
                <>
                    <p
                    style={style}
                        className={`${type} ${classes}`}
                        dangerouslySetInnerHTML={{
                            __html: (isExpanded || !shouldTruncate ? text : truncatedText).replace(
                                /\n/g,
                                "<br />"
                            ),
                        }}
                    />
                    {shouldTruncate && (
                        <a
                            onClick={toggleExpand}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.key === 'Space') {
                                    e.preventDefault();
                                    toggleExpand();
                                }
                            }}
                            tabIndex={0}
                            role="button"
                            aria-expanded={isExpanded}
                            className="inline-flex justify-center items-center gap-2 mt-2 cursor-pointer"
                        >
                            <div className="b_a1 text-Text-primary underline leading-6 tracking-wider">
                            {isExpanded ? viewLessText : viewMoreText}
                            </div>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="text-Text-primary"
                                style={{ transform: isExpanded ? "rotate(180deg)" : "none", transition: "transform 180ms ease" }}
                                aria-hidden="true"
                                focusable="false"
                            >
                                <path d="M18.707 12.707L17.293 11.293L13 15.586V6H11V15.586L6.70703 11.293L5.29303 12.707L12 19.414L18.707 12.707Z" fill="currentColor" />
                            </svg>
                        </a>
                    )}
                </>
            );
        } else if (Array.isArray(text)) {
            // Render each item in the array, checking if it's a valid React element or plain text
            return text.map((item, index) =>
                React.isValidElement(item) ? (
                    <React.Fragment key={index}>{item}</React.Fragment>
                ) : (
                    <p
                        key={index}
                        className={`${type} ${classes}`}
                        dangerouslySetInnerHTML={{
                            __html: item.replace(/\n/g, "<br />"),
                        }}
                    />
                )
            );
        } else {
            // Handle non-string, non-array cases as plain text
            return <p  className={`${type} ${classes}`} styles={style}>{text}</p>;
        }
    };

    return <div>{renderText()}</div>;
};

export default Paragraph;
